import(/* webpackMode: "eager" */ "/var/www/front/live/eduvalu-front/app/smartBooks/CoursesPage.tsx")